import config from "@/config";

export function openOAuthRedirect(provider: string) {
  window.location.href = `${config.yapiUrl}/oauth/${provider}/?redirectUri=${config.appUrl}`;
}
